<rundna-website-wrapper>
  <span header-1>TRAINING PROGRAMS</span>
  <span header-2>RunDNA Marketplace</span>
  <span text>Find a program that meets your needs to help you crush your goals from leading coaches and fitness/medical professionals. As part of your program, you will have access to RunDNA to track your progress, get detailed instructions and get key insights.  Purchasing a program is for personal use and includes 12 months of access to the program.</span>
  <router-outlet></router-outlet>
</rundna-website-wrapper>